import LineGradient from "../components/LineGradient";
import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";
import skill from '../assets/skills.jpeg'

const AboutMe = () => {
  const isAboveLarge = useMediaQuery("(min-width: 1060px)");
  return (
    <section id="about" className=" pb-12">
      {/* HEADER AND IMAGE SECTION */}
      <div className="mt-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <p className="font-playfair font-semibold text-4xl mb-5">
            <span className="text-cyan-500">ABOUT ME</span>
          </p>

          <p className="mt-2 text-justify">

            **Lubaba Aunjum**
            <br />
            **Full Stack Web Developer | Frontend Specialist**
            <br />
            As a software developer with a passion for frontend technologies and a growing expertise in full-stack development, I bring extensive experience from the corporate sector as a frontend developer. I excel in translating client needs into visually compelling and efficient web solutions. My technical toolkit includes React.js, Next.js, Bootstrap, JavaScript, Tailwind CSS, and React Native, enabling me to craft responsive and user-friendly applications.
            <br />
            Web development is my creative outlet, where I innovate and enhance user experiences through intuitive design and functionality. My portfolio showcases a commitment to excellence and a keen focus on staying ahead of industry trends, as evidenced by my GitHub contributions. With a strong record in professional client interactions and handling full-stack projects, I am enthusiastic about collaborating with dynamic teams and contributing to projects that elevate user experience.
            <br />
            For inquiries or collaboration opportunities, please reach out at aunjumtuli109@gmail.com. Let's create exceptional digital experiences together!
          </p>
        </motion.div>

      </div>

    </section>
  );
};

export default AboutMe;
